import React from 'react';
import Typography from '@material-ui/core/Typography';

const NotFound = () => {
  return (
      <Typography variant={'h3'}>
        This url does not lead to a valid page....
      </Typography>
  )
}

export default NotFound;